import { render, staticRenderFns } from "./InsuranceClaimDetail.vue?vue&type=template&id=3a2ed225"
import script from "./InsuranceClaimDetail.vue?vue&type=script&lang=js"
export * from "./InsuranceClaimDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports